/* 
  1.该文件用于管理整个项目的ajax请求，项目有多少个接口，这里就有多少个函数与之对应
  2.该文件中的函数，都有一个特点，名字都叫reqXxxxxx
*/
import request from '@/utils/request'
import mockRequest from '@/utils/mockRequest'

// 该函数专门用于请求【首页的三级分类信息】
export const reqCategoryList = () => request.get('/api/product/getBaseCategoryList')

// 该函数专门用于请求【首页的轮播图信息】
export const reqSildeList = () => mockRequest.get('/slide')

// 该函数专门用于请求【首页的楼层信息】
export const reqFloorList = () => mockRequest.get('/floor')

// 该函数专门用于请求【搜索】
export const reqSearchInfo = (params) => request.post('/api/list',params)

// 该函数专门用于请求【商品详细信息】
export const reqGoodsInfo = (id) => request.get(`/api/item/${id}`)

// 该函数专门用于请求【添加商品到购物车】
export const reqAddToCart = (id,num) => request.post(`/api/cart/addToCart/${id}/${num}`)

// 该函数专门用于请求【购物车数据】
export const reqCartList = () => request.get('/api/cart/cartList')

// 该函数专门用于请求【勾选购物车中商品】
export const reqCheckOne = (skuId,isChecked) => request.get(`/api/cart/checkCart/${skuId}/${isChecked}`)

// 该函数专门用于请求【全选购物车中商品】
export const reqCheckAll = (skuIdList,isChecked) => request.post(`/api/cart/batchCheckCart/${isChecked}`,skuIdList)

// 该函数专门用于请求【删除购物车中商品】
export const reqDeleteOne = (skuId) => request.delete(`/api/cart/deleteCart/${skuId}`)

// 该函数专门用于请求【批量删除购物车中商品】
export const reqBatchDelete = (skuIdList) => request.post(`/api/cart/batchDeleteCart`,skuIdList)

// 该函数专门用于请求【验证码】
export const reqCode = (phone) => request.get(`/api/user/passport/sendCode/${phone}`)

// 该函数专门用于请求【注册】
export const reqRegister = (registerObj) => request.post(`/api/user/passport/register`,registerObj)

// 该函数专门用于请求【登录】
export const reqLogin = (loginObj) => request.post('/api/user/passport/login',loginObj)

// 该函数专门用于请求【用户信息】，不用携带任何参数，因为请求头中已经有了token
export const reqUserInfo = () => request.get('/api/user/passport/auth/getUserInfo')

// 该函数专门用于请求【退出登录】，不用携带任何参数，因为请求头中已经有了token
export const reqLogout = () => request.get('/api/user/passport/logout')

// 该函数专门用于请求【交易信息】，不用携带任何参数，因为请求头中已经有了token
export const reqTradeInfo = () => request.get('/api/order/auth/trade')

// 该函数专门用于【提交订单】
export const reqSubmitOrder = (tradeNo,params) => request.post(`/api/order/auth/submitOrder?tradeNo=${tradeNo}`,params)

// 该函数专门用于【获取支付信息】
export const reqPayInfo = (order_id) => request.get(`/api/payment/weixin/createNative/${order_id}`)

// 该函数用于获取订单支付状态
export const reqPayStatus = (order_id) => request.get(`/api/payment/weixin/queryPayStatus/${order_id}`)

// 该函数用于获取当前用户订单
export const reqOrderInfo = (pageNo,pageSize) => request.get(`/api/order/auth/${pageNo}/${pageSize}`)

